<template>
  <div>
    <v-img max-height="100px" contain :src="objectif.image" class="" rounded> </v-img>
    <div class="mb-3">
      <h2 class="headline mb-2">{{ objectif.titre }}</h2>
      <h3 class="subtitle-1">{{ objectif.sousTitre }}</h3>
      <p class="description-text" v-show="objectif.description" v-html="objectif.description"></p>
    </div>

    <ObjectifProgress :amasse="objectif.amasse" :objectif="objectif.objectif" />

    <p class="pt-0 black--text text-right">
      <template v-if="!objectif.nombreParticipants || objectif.nombreParticipants === 0"> {{ $t("objectifCard.premierparticipant") }} </template>
      <template v-else-if="objectif.nombreParticipants === 1"> {{ objectif.nombreParticipants }} {{ $t("objectifCard.participant") }} </template>
      <template v-else> {{ objectif.nombreParticipants }} {{ $t("objectifCard.participants") }} </template>
    </p>

    <v-sheet v-if="!hideMessages" outlined class="mx-auto pa-4 pa-md-6 my-6 my-md-12 grey lighten-4">
      <Participants :participants="objectif.participants"> </Participants>
    </v-sheet>

    <div class="text-center" v-if="!hideDonationButton">
      <v-btn
        x-large
        link
        class="px-12 py-8"
        color="primary"
        exact
        :to="{
          name: 'Objectif',
          params: { identifiantCollecte: this.$route.params.identifiantCollecte, identifiantObjectif: this.objectif.identifiant },
          query: { ...$route.query }
        }"
        :title="$t('objectifCard.faireundon')"
      >
        {{ $t("objectifCard.faireundon") }}
        <v-icon class="ml-1">mdi-heart</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import urlMixin from "@/mixins/urlMixin"
import Participants from "./Participants"
import ObjectifProgress from "./ObjectifProgress"

export default {
  name: "ObjectifCard",
  mixins: [urlMixin],
  props: {
    objectif: Object,
    hideDonationButton: {
      type: Boolean,
      default: false
    },
    hideMessages: {
      type: Boolean,
      default: false
    }
  },
  components: { Participants, ObjectifProgress }
}
</script>